import { render, staticRenderFns } from "./WhatsAppGroupIDPicker.vue?vue&type=template&id=25518d65"
import script from "./WhatsAppGroupIDPicker.vue?vue&type=script&lang=js"
export * from "./WhatsAppGroupIDPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports